import React, { useState } from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';

const sections = [
  {
    id: 'neurobehavioral',
    title: 'Solace Neurobehavioral And Child Guidance Center',
    shortTitle: 'Neurobehavioral',
    subtitle: 'Specialized care for neurobehavioral assessments and child guidance therapies',
    images: [
      { id: 1,  src: "https://s3.thoughtdiary.ai/mysolace/web/gallery/ext2.jpg",  alt: "" },
      { id: 2,  src: "https://s3.thoughtdiary.ai/mysolace/web/gallery/int3.jpg",  alt: "" },
      { id: 3,  src: "https://s3.thoughtdiary.ai/mysolace/web/gallery/int6.webp", alt: "" },
      { id: 4,  src: "https://s3.thoughtdiary.ai/mysolace/web/gallery/int2.jpg",  alt: " " },
      { id: 5,  src: "https://s3.thoughtdiary.ai/mysolace/web/gallery/int5.webp",  alt: "" },
      { id: 6,  src: "https://s3.thoughtdiary.ai/mysolace/web/gallery/int1.jpg", alt: "" },
    ],
  },
  {
    id: 'premier',
    title: 'Solace Premier',
    shortTitle: 'Premier',
    subtitle: 'Premium mental health care with world-class facilities and individualized treatment plans',
    images: [
      { id: 7,  src: "https://s3.thoughtdiary.ai/mysolace/web/gallery/ext3.jpg",  alt: "" },
      { id: 8,  src: "https://s3.thoughtdiary.ai/mysolace/web/gallery/int4.webp",  alt: "" },
      { id: 9,  src: "https://s3.thoughtdiary.ai/mysolace/web/gallery/int7.webp", alt: "" },
      { id: 10, src: "https://s3.thoughtdiary.ai/mysolace/web/gallery/int8.webp", alt: "" },
      { id: 11, src: "https://s3.thoughtdiary.ai/mysolace/web/gallery/int4.webp", alt: "" },
      { id: 12, src: "https://s3.thoughtdiary.ai/mysolace/web/gallery/int1.jpg",  alt: "" },
    ],
  },
  {
    id: 'kids',
    title: 'Solace Kids and CAP',
    shortTitle: 'Kids & CAP',
    subtitle: 'A nurturing space dedicated to child and adolescent psychiatry services',
    images: [
      { id: 13, src: "https://s3.thoughtdiary.ai/mysolace/web/gallery/ext3.jpg",  alt: "" },
      { id: 14, src: "https://s3.thoughtdiary.ai/mysolace/web/gallery/int4.webp", alt: "" },
      { id: 15, src: "https://s3.thoughtdiary.ai/mysolace/web/gallery/int6.webp", alt: "" },
      { id: 16, src: "https://s3.thoughtdiary.ai/mysolace/web/gallery/int2.jpg",  alt: "" },
      { id: 17, src: "https://s3.thoughtdiary.ai/mysolace/web/gallery/int5.webp", alt: "" },
      { id: 18, src: "https://s3.thoughtdiary.ai/mysolace/web/gallery/int7.webp", alt: "" },
    ],
  },
  {
    id: 'village',
    title: 'Solace Village',
    shortTitle: 'Village',
    subtitle: 'A community-centered residential environment for holistic recovery and wellness',
    images: [
      { id: 19, src: "https://s3.thoughtdiary.ai/mysolace/web/gallery/ext1.jpg",  alt: "" },
      { id: 20, src: "https://s3.thoughtdiary.ai/mysolace/web/gallery/int8.webp", alt: "" },
      { id: 21, src: "https://s3.thoughtdiary.ai/mysolace/web/gallery/int1.jpg",  alt: "" },
      { id: 22, src: "https://s3.thoughtdiary.ai/mysolace/web/gallery/int3.jpg",  alt: "" },
      { id: 23, src: "https://s3.thoughtdiary.ai/mysolace/web/gallery/ext2.jpg",  alt: "" },
      { id: 24, src: "https://s3.thoughtdiary.ai/mysolace/web/gallery/int4.webp", alt: "" },
    ],
  },
  {
    id: 'senior',
    title: 'Solace Senior Care',
    shortTitle: 'Senior Care',
    subtitle: 'Compassionate care tailored for the unique mental and emotional needs of older adults',
    images: [
      { id: 25, src: "https://s3.thoughtdiary.ai/solace-seniorcare/Gallery/SAN04260.JPG", alt: " " },
      { id: 26, src: "https://s3.thoughtdiary.ai/solace-seniorcare/Gallery/SAN04235.JPG", alt: "" },
      { id: 27, src: "https://s3.thoughtdiary.ai/solace-seniorcare/Gallery/SAN04238.JPG",  alt: "" },
      { id: 28, src: "https://s3.thoughtdiary.ai/solace-seniorcare/Gallery/SAN04239.JPG",  alt: "" },
      { id: 29, src: "https://s3.thoughtdiary.ai/solace-seniorcare/Gallery/SAN04662.JPG", alt: "" },
      { id: 30, src: "https://s3.thoughtdiary.ai/solace-seniorcare/Gallery/SAN04139.JPG", alt: " " },
    ],
  },
];

const allImages = sections.flatMap((s) =>
  s.images.map((img) => ({ ...img, sectionTitle: s.title }))
);

let _counter = 0;
const startIndices = sections.map((s) => { const n = _counter; _counter += s.images.length; return n; });

// ── Image Card ──────────────────────────────────────────────
const ImageCard = ({ image, globalIdx, onOpen, style }) => (
  <div
    onClick={() => onOpen(globalIdx)}
    className="group cursor-pointer overflow-hidden"
    style={{ ...style, borderRadius: '6px', position: 'relative' }}
  >
    <img
      src={image.src}
      alt={image.alt}
      style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block',
        transition: 'transform 0.7s cubic-bezier(0.25,0.46,0.45,0.94)' }}
      className="group-hover:scale-110"
    />
    <div
      className="absolute inset-0 transition-opacity duration-500"
      style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.78) 0%, rgba(0,0,0,0) 55%)', opacity: 0 }}
      ref={(el) => {
        if (el) {
          el.parentElement.addEventListener('mouseenter', () => { el.style.opacity = 1; });
          el.parentElement.addEventListener('mouseleave', () => { el.style.opacity = 0; });
        }
      }}
    />
    <div
      className="absolute bottom-0 left-0 right-0 px-4 py-3"
      style={{ transform: 'translateY(100%', transition: 'transform 0.4s ease' }}
      ref={(el) => {
        if (el) {
          el.parentElement.addEventListener('mouseenter', () => { el.style.transform = 'translateY(0)'; });
          el.parentElement.addEventListener('mouseleave', () => { el.style.transform = 'translateY(100%)'; });
        }
      }}
    >
      <p style={{ color: '#fff', fontSize: '11px', letterSpacing: '0.14em', textTransform: 'uppercase', fontWeight: 500, margin: 0, fontFamily: 'sans-serif' }}>
        {image.alt}
      </p>
    </div>
  </div>
);

// ── Gallery Grid ─────────────────────────────────────────────
const GalleryGrid = ({ images, startIdx, onOpen }) => (
  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '6px' }}>
    <ImageCard image={images[0]} globalIdx={startIdx + 0} onOpen={onOpen}
      style={{ gridColumn: '1 / 3', gridRow: '1', aspectRatio: '16/9' }} />
    <ImageCard image={images[1]} globalIdx={startIdx + 1} onOpen={onOpen}
      style={{ gridColumn: '3', gridRow: '1', aspectRatio: '3/4' }} />
    <ImageCard image={images[2]} globalIdx={startIdx + 2} onOpen={onOpen}
      style={{ gridColumn: '1', gridRow: '2', aspectRatio: '4/3' }} />
    <ImageCard image={images[3]} globalIdx={startIdx + 3} onOpen={onOpen}
      style={{ gridColumn: '2', gridRow: '2', aspectRatio: '4/3' }} />
    <ImageCard image={images[4]} globalIdx={startIdx + 4} onOpen={onOpen}
      style={{ gridColumn: '3', gridRow: '2', aspectRatio: '4/3' }} />
    <ImageCard image={images[5]} globalIdx={startIdx + 5} onOpen={onOpen}
      style={{ gridColumn: '1 / 4', gridRow: '3', aspectRatio: '21/6' }} />
  </div>
);

// ── Main Component ───────────────────────────────────────────
const Gallery = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [modalIndex, setModalIndex] = useState(null);

  const openModal = (i) => setModalIndex(i);
  const closeModal = () => setModalIndex(null);
  const navigate = (dir) =>
    setModalIndex((prev) =>
      dir === 'next' ? (prev + 1) % allImages.length : (prev - 1 + allImages.length) % allImages.length
    );

  const activeSection = sections[activeTab];

  return (
    <div style={{ minHeight: '100vh', background: '#00A785' }}>

      {/* ── Tab Bar ── */}
      <div style={{ borderTop: '1px solid rgba(255,255,255,0.08)', borderBottom: '1px solid rgba(255,255,255,0.08)', background: '#00A785', overflowX: 'auto' }}>
        <div style={{ display: 'flex', maxWidth: 1200, margin: '0 auto', padding: '0 24px', justifyContent: 'center' }}>
          {sections.map((s, i) => {
            const isActive = activeTab === i;
            return (
              <button
                key={s.id}
                onClick={() => setActiveTab(i)}
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  padding: '20px 24px',
                  position: 'relative',
                  whiteSpace: 'nowrap',
                  transition: 'all 0.3s ease',
                  flexShrink: 0,
                }}
              >
                {/* Active indicator line */}
                <div style={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  right: 0,
                  height: '2px',
                  background: isActive ? '#e8d5a3' : 'transparent',
                  transition: 'background 0.3s ease',
                }} />
                {/* Tab number */}
                <span style={{
                  display: 'block',
                  fontSize: '9px',
                  letterSpacing: '0.3em',
                  textTransform: 'uppercase',
                  fontFamily: 'sans-serif',
                  color: isActive ? '#e8d5a3' : 'rgba(255,255,255,0.6)',
                  marginBottom: 5,
                  transition: 'color 0.3s ease',
                }}>
                  {String(i + 1).padStart(2, '0')}
                </span>
                {/* Tab label */}
                <span style={{
                  display: 'block',
                  fontSize: '13px',
                  letterSpacing: '0.04em',
                  fontFamily: 'sans-serif',
                  fontWeight: isActive ? 500 : 300,
                  color: isActive ? '#f5f0e8' : 'rgba(245,240,232,0.7)',
                  transition: 'all 0.3s ease',
                }}>
                  {s.shortTitle}
                </span>
              </button>
            );
          })}
        </div>
      </div>

      {/* ── Active Section Content ── */}
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '56px 24px 80px' }}>

        {/* Section heading */}
        <div style={{ textAlign: 'center', marginBottom: 48 }}>
          <h2 style={{ color: '#f5f0e8', fontSize: 'clamp(20px, 3vw, 30px)', fontWeight: 400, letterSpacing: '0.04em', margin: '0 0 16px', lineHeight: 1.3 }}>
            {activeSection.title}
          </h2>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12, marginBottom: 14 }}>
            <div style={{ height: '1px', width: 40, background: 'rgba(255,255,255,0.25)' }} />
            <div style={{ width: 4, height: 4, borderRadius: '50%', background: '#e8d5a3' }} />
            <div style={{ height: '1px', width: 40, background: 'rgba(255,255,255,0.25)' }} />
          </div>
          <p style={{ color: 'rgba(255,255,255,0.85)', fontSize: '13px', fontFamily: 'sans-serif', fontWeight: 300, letterSpacing: '0.02em', lineHeight: 1.7, maxWidth: 480, margin: '0 auto' }}>
            {activeSection.subtitle}
          </p>
        </div>

        {/* Grid */}
        <GalleryGrid
          images={activeSection.images}
          startIdx={startIndices[activeTab]}
          onOpen={openModal}
        />
      </div>

      {/* ── Lightbox Modal ── */}
      {modalIndex !== null && (
        <div
          onClick={closeModal}
          style={{ position: 'fixed', inset: 0, zIndex: 50, background: 'rgba(0,80,64,0.97)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}
        >
          <div onClick={(e) => e.stopPropagation()} style={{ position: 'relative', maxWidth: 1000, width: '100%' }}>

            <button onClick={closeModal} aria-label="Close"
              style={{ position: 'absolute', top: -48, right: 0, background: 'none', border: 'none',
                cursor: 'pointer', color: '#a8d4cf', padding: 4, lineHeight: 1 }}
              onMouseEnter={(e) => e.currentTarget.style.color = '#f5f0e8'}
              onMouseLeave={(e) => e.currentTarget.style.color = '#a8d4cf'}
            >
              <X size={22} />
            </button>

            <button onClick={() => navigate('prev')} aria-label="Previous"
              style={{ position: 'absolute', left: -52, top: '50%', transform: 'translateY(-50%)',
                background: 'none', border: '1px solid rgba(168,212,207,0.25)', borderRadius: '50%', width: 40, height: 40,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                cursor: 'pointer', color: '#a8d4cf', transition: 'all 0.2s' }}
              onMouseEnter={(e) => { e.currentTarget.style.borderColor = '#e8d5a3'; e.currentTarget.style.color = '#e8d5a3'; }}
              onMouseLeave={(e) => { e.currentTarget.style.borderColor = 'rgba(168,212,207,0.25)'; e.currentTarget.style.color = '#a8d4cf'; }}
            >
              <ChevronLeft size={18} />
            </button>

            <button onClick={() => navigate('next')} aria-label="Next"
              style={{ position: 'absolute', right: -52, top: '50%', transform: 'translateY(-50%)',
                background: 'none', border: '1px solid rgba(168,212,207,0.25)', borderRadius: '50%', width: 40, height: 40,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                cursor: 'pointer', color: '#a8d4cf', transition: 'all 0.2s' }}
              onMouseEnter={(e) => { e.currentTarget.style.borderColor = '#e8d5a3'; e.currentTarget.style.color = '#e8d5a3'; }}
              onMouseLeave={(e) => { e.currentTarget.style.borderColor = 'rgba(168,212,207,0.25)'; e.currentTarget.style.color = '#a8d4cf'; }}
            >
              <ChevronRight size={18} />
            </button>

            <img
              src={allImages[modalIndex].src}
              alt={allImages[modalIndex].alt}
              style={{ maxWidth: '100%', maxHeight: '78vh', objectFit: 'contain',
                borderRadius: 4, display: 'block', margin: '0 auto' }}
            />

            <div style={{ marginTop: 24, textAlign: 'center' }}>
              <p style={{ color: '#f5f0e8', fontSize: '14px', letterSpacing: '0.08em', fontWeight: 400, margin: '0 0 6px' }}>
                {allImages[modalIndex].alt}
              </p>
              <p style={{ color: '#e8d5a3', fontSize: '10px', letterSpacing: '0.3em', textTransform: 'uppercase', fontFamily: 'sans-serif', margin: '0 0 8px' }}>
                {allImages[modalIndex].sectionTitle}
              </p>
              <p style={{ color: '#a8d4cf', fontSize: '11px', fontFamily: 'sans-serif', letterSpacing: '0.1em', margin: 0 }}>
                {modalIndex + 1} / {allImages.length}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;